export const TOKEN_KEY = "auth";
export const isAuthenticated = () => sessionStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const login = token => {
  sessionStorage.setItem(TOKEN_KEY, JSON.stringify(token));
};
export const logout = () => {
  sessionStorage.removeItem(TOKEN_KEY);
};